import { Component, Input,  OnInit ,  Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
	userName: String;
	@Input() showHeader: Boolean;
  @Output() emitPass: EventEmitter<any> = new EventEmitter<any>();
  ngOnInit() {
    this.userName = localStorage.getItem('name');
    console.log(localStorage.getItem('locale'))
  }
  
  constructor(  private router: Router) {  
  }

  logout() {
	  localStorage.clear();
    this.showHeader = false;
    this.emitPass.emit(this.showHeader);
	  this.router.navigate(['/']);
  }
}
